import Clear from '@/layouts/Clear.vue';

export default {
  path: '/subspecialties',
  component: Clear,
  children: [
    {
      path: '',
      name: 'subspecialties.index',
      component: () => import('@/views/Subspecialty/SubspecialtyList.vue'),
    },
    {
      path: ':id?',
      name: 'subspecialties.save',
      component: () => import('@/views/Subspecialty/Subspecialty.vue'),
    },
  ],
};
